import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="max-w-2xl mx-auto px-4 py-24 text-center">
      <XCircle size={72} className="mx-auto text-slate-900 mb-6" />
      <h1 className="font-display font-black text-4xl uppercase tracking-tight">Payment Cancelled</h1>
      <p className="mt-3 text-slate-600">Your order was not charged. You can retry from your cart anytime.</p>
      <div className="mt-10 flex gap-3 justify-center">
        <Link to="/cart" className="border border-slate-900 hover:bg-slate-900 hover:text-white px-5 py-3 text-xs font-bold uppercase tracking-widest">Back to Cart</Link>
        <Link to="/products" className="bg-orange-600 hover:bg-orange-700 text-white px-5 py-3 text-xs font-bold uppercase tracking-widest">Continue Shopping</Link>
      </div>
    </div>
  );
}
